export default __webpack_public_path__ + "static/media/claim_Procedure.ddcc4c73.pdf";